import { Component, EventEmitter, OnInit, Output, QueryList, ViewChildren, Input, SimpleChanges, OnChanges } from '@angular/core';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';


@Component({
  selector: 'app-background-check-list',
  templateUrl: './background-check-list.component.pug',
  styleUrls: ['./background-check-list.component.scss'],
  standalone: false
})
export class BackgroundCheckListComponent implements OnInit {
  @ViewChildren('nestedDropdown') dropdowns!: QueryList<BsDropdownDirective>;
  @Input() alreadySelectedChecksList: any = [];
  @Input() alreadySelectedFlow: any = {};
  @Input() alreadySelectedFlows: any[] = [];
  @Input() backgroundChecksList: any = [];
  @Input() searchValue: any = "";
  @Output() backgroundCheck = new EventEmitter();
  @Output() backgroundChecks = new EventEmitter();
  @Output() flow = new EventEmitter();
  backgroundCheckSelected: any;
  selectedBackgroundChecks: any = {};
  flowSelected = 0;
  flowName = '';

  flowSelections: any[] = [];

  ENT_8918_MULTIPLE_BC = false;
  TRUST_752_VERIFICATION = false;

  constructor(private permissionService: PermissionsService) {}

  ngOnInit(): void {
    this.ENT_8918_MULTIPLE_BC = this.permissionService.isFeatureActivated('ent_8918_multiple_bg_checks');
    this.TRUST_752_VERIFICATION = this.permissionService.isFeatureActivated('trust-752-certn-checks');
    if(this.ENT_8918_MULTIPLE_BC){
      if (this.alreadySelectedChecksList && this.alreadySelectedChecksList.length){
        this.selectedBackgroundChecks = this.alreadySelectedChecksList.reduce((acc, obj) => {
          acc[obj.uid] = obj;
          return acc
        }, {});
      }
      
      if(this.TRUST_752_VERIFICATION && this.alreadySelectedFlows){
        this.flowSelections = this.alreadySelectedFlows;
      }
      else{
        if (this.alreadySelectedFlow){
          this.flowSelected = this.alreadySelectedFlow.uid;
          this.flowName = this.alreadySelectedFlow.name;
        }
      }
    }
  }

  closeSubDropdown() {
    this.dropdowns.forEach((dropdown, index) => {
      if (dropdown.isOpen) dropdown.hide();
    });
  }

  selectBackgroundCheck(checkSelected, check) {
    // checkSelected will either be true or false, denoting a checkbox selection
    if (!checkSelected) delete this.selectedBackgroundChecks[check.uid]
    else this.selectedBackgroundChecks[check.uid] = check

    if (checkSelected && check.flow_names?.length > 0) {

      if(this.TRUST_752_VERIFICATION){
        const existingIndex = this.flowSelections.findIndex(
        sel => sel.parent_short === check.short_name
      );

      if (existingIndex !== -1) {
        // Update existing entry
        this.flowSelections[existingIndex] = {
          id: check.flow_names[0].uid,
          name: check.flow_names[0].name,
          short_name: check.flow_names[0].short_name,
          parent_short: check.short_name
        };
      } else {
        // Add new entry
        this.flowSelections.push({
          id: check.flow_names[0].uid,
          name: check.flow_names[0].name,
          short_name: check.flow_names[0].short_name,
          parent_short: check.short_name
        });
      }
        this.flow.emit(this.flowSelections);
      }
      else{
          this.flowSelected = check.flow_names[0].uid;
          this.flowName = check.flow_names[0].name;
          check.short_name = check.flow_names[0].short_name;
          this.flow.emit(check.flow_names[0])
      }

    } else {
      if(this.TRUST_752_VERIFICATION){
        this.flowSelections = this.flowSelections.filter(
          sel => sel.parent_short !== check.short_name
        );
        this.flow.emit(this.flowSelections);
      }
      else {
        // when mobile ID check is unselected, empty out everything
        // otherwise keep previously selected flow details
        this.flowSelected = !checkSelected && check.flow_names ? 0 : this.flowSelected;
        this.flowName = !checkSelected && check.flow_names ? '' : this.flowName;
        this.flow.emit(!this.flowName ? this.flowName : this.alreadySelectedFlow);
      }
    }
    this.backgroundChecks.emit(Object.values(this.selectedBackgroundChecks))
  }

  selectedBackgroundCheck(check) {
    this.backgroundCheckSelected = check.uid;
    if (check.flow_names?.length > 0) {
      this.flowSelected = check.flow_names[0].uid;
      this.flowName = check.flow_names[0].name;
      check.short_name = check.flow_names[0].short_name;
      this.flow.emit(check.flow_names[0])
    } else {
      this.flowSelected = 0;
      this.flowName = '';
      this.flow.emit(this.flowName);
    }
    this.backgroundCheck.emit(check)
  }

  selectedFlow(flow, check) {
    // flow here is the child check for mobile id checks, id_doc_one etc.
    // check is the parent check, i.e mobile_id
    if(this.TRUST_752_VERIFICATION){
      const existingIndex = this.flowSelections.findIndex(
        sel => sel.parent_short === check.short_name
      );

      if (existingIndex !== -1) {
        // Update existing entry
        this.flowSelections[existingIndex] = {
          id: flow.uid,
          name: flow.name,
          short_name: flow.short_name,
          parent_short: check.short_name
        };
      } else {
        // Add new entry
        this.flowSelections.push({
          id: flow.uid,
          name: flow.name,
          short_name: flow.short_name,
          parent_short: check.short_name
        });
      }

      this.selectedBackgroundChecks[check.uid] = check;
      this.backgroundChecks.emit(Object.values(this.selectedBackgroundChecks))

      // Todo
      this.flow.emit(this.flowSelections);
    }
    else {
      this.flowSelected = flow.uid;
      this.flowName = flow.name;

      if(this.ENT_8918_MULTIPLE_BC)
        this.selectedBackgroundChecks[check.uid] = check;
      else
        this.backgroundCheckSelected = check.uid

      check.short_name = flow.short_name;
      if(this.ENT_8918_MULTIPLE_BC)
        this.backgroundChecks.emit(Object.values(this.selectedBackgroundChecks))
      else
        this.backgroundCheck.emit(check)
      const selectedFlowObj = check.flow_names.find(flowObj => flowObj.uid === this.flowSelected);

      this.flow.emit(selectedFlowObj)
    }

  }

  formatData(categories: string[]): string {
    return categories.join(', ');
  }

  getSelectedCheckIds(){
    return Object.keys(this.selectedBackgroundChecks)
  }

  isFlowSelected(flowId: string): boolean {
    return this.flowSelections.some(sel => sel.id === flowId);
  }

  getSelectedFlowName(flowId: string): string | null {
    const match = this.flowSelections.find(f => f.parent_short === flowId);
    return match ? match.name : null;
  }
}
